import { setTheme } from "theme/default/setTheme";

export const color_0083f5 = setTheme(({ theme }) => theme.colors.color_0083f5);
